import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, mergeMap, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { FirebaseService } from 'src/app/services/firebase.service';

/** Guards routes to any authenticated users */
export const userGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const firebaseService = inject(FirebaseService);
  const router = inject(Router);

  return authService.authReady.pipe(
    mergeMap((authReady) => {
      if (!authReady || !authService.signedIn) {
        console.log('auth not ready, or user not signed in');
        localStorage.setItem('redirectAfterLoginUrl', state.url);
        // Preserve query params
        return router.navigate(['/login'], {
          queryParams: state.root.queryParams,
        });
      }

      return of(true);
    }),
    catchError((err, caught) => {
      console.error(err as Error);
      try {
        firebaseService.logErrorEvent(err);
      } catch (err) {
        console.error(err as Error);
      }

      return of(false);
    })
  );
};
